import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './ListYourProperty.less';

export class ListYourProperty extends React.Component {
    static contextType = TrackingContext;

    static propTypes = {
        isInverse: PropTypes.bool,
        text: PropTypes.string.isRequired,
    };

    static defaultProps = {
        isInverse: false,
    };

    constructor(props, context) {
        super(props, context);
        this.handleClickLYP = this.handleClickLYP.bind(this);
    }

    handleClickLYP() {
        const fields = {
            actionlocation: 'header.lyp'
        };
        this.context.trigger('header.link.click', fields);
    }

    get attrs() {
        return {
            className: this.className,
            'data-bypass': true,
            href: this.props.link,
        };
    }

    get className() {
        return classNames(
            'site-header-list-your-property',
            'btn', 'btn-default', 'btn-sm',
            this.props.isInverse && 'btn-inverse',
        );
    }

    render() {
        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
            <a {...this.attrs} target="_blank" onClick={this.handleClickLYP}>{this.props.text}</a>
        );
    }
}
